import * as React from 'react';
import { IActions, actionCreator } from './store/actions/creators';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { Grid, StyledComponentProps } from '@material-ui/core';
import { IApplicationState } from '../../store/ApplicationState';
import { connect } from 'react-redux';
import Filters from './components/Filter/Filters';
import TagList from './components/List/TagList';
import { tag } from '../../model/tag';
import Paper from '../../ui-components/Containers/Paper';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './styles';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { IState } from './store/state';
import { Detail } from './components/Detail/detail';
import { Followers } from './components/Detail/followers';
import { Export } from './components/Export';

interface IProps extends IActions, IState, StyledComponentProps, IMediaQueryProps {
    tags: tag[];
    navigateTo: (path: string) => void;
    match: {
        params: {
            id: string
        }
    }
}

interface IInternalState {
    tagsCollapsed: boolean;
}

class CompContainer extends React.Component<IProps, IInternalState>
{
    state = { tagsCollapsed: false };

    componentDidMount() {

        this.props.loadTags().then(resp => {
            let id = resp.length > 0 ? resp[0]._id : "";
            if(id){
                this.handleTagSelection(id)
            }
        });

        const { id } = this.props.match.params;
        if (id) {
            this.props.loadTag(id);
        }
        else {
            this.props.clearSelection();
        }
    }
    handleTagSelection = (id: string) => {
        if (this.props.smallScreen)
            this.setState({ tagsCollapsed: true });
        this.props.navigateTo(`/private/Tags/${id}`);
        this.props.loadTag(id);
    }
    editTag = (tag: tag) => {
        if (this.props.smallScreen)
            this.setState({ tagsCollapsed: true });
        this.props.navigateTo(`/private/Tags/${tag._id}`);
        this.props.editTag(tag);
    }
    toggleCotactsSectionCollapse = () => {
        this.setState({ tagsCollapsed: !this.state.tagsCollapsed });
    }

    render() {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Filters
                        addTag={this.props.saveTag}
                        loadTags={this.props.loadTags}
                        classes={this.props.classes}
                        smallScreen={this.props.smallScreen} />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Paper title='Elenco'
                        collapsed={this.props.smallScreen ? this.state.tagsCollapsed : undefined}
                        toggleCollapse={this.toggleCotactsSectionCollapse}
                        fullHeight={!this.props.smallScreen}
                        contentContainerStyle={this.props.smallScreen ? { height: '300px', overflow: 'auto' } : {}}
                    >
                        <TagList
                            tagList={this.props.tags}
                            selected={this.props.tag ? this.props.tag._id : undefined}
                            selectTag={this.handleTagSelection}
                            classes={this.props.classes}
                            edit={this.editTag}
                        />
                        <Export print={() => { window.print(); }} download={() => {  }} />
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Paper title='Dati' fullHeight>
                        {this.props.tag && this.props.edit && <Detail
                            classes={this.props.classes}
                            tag={this.props.tag}
                            save={this.props.saveTag}
                            readonly={!this.props.edit}
                            undo={this.props.loadTag}
                            onChange={this.props.updateTag} />}
                        {this.props.tag && !this.props.edit && <Followers
                            tag={this.props.tag}
                            classes={this.props.classes}
                        />}
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IApplicationState) => ({
    ...state.tags
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        ...actionCreator(dispatch),
        navigateTo: authActions(dispatch).navigateTo
    }
};

export const Tags = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(WithMediaQuery(CompContainer)));